import React, { useEffect, useState } from "react";
import "./Contect.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import axios from "axios";
import Footer2 from "../../components/Footer2";
import ReCAPTCHA from "react-google-recaptcha";
const Contect = () => {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    regarding: "",
    news: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleContact = async () => {
    if (!formdata.name || !formdata.email || !formdata.regarding) {
      alert('Please fill input fields')
    }
    else {
      await axios
        .post("http://localhost:3001/contact", formdata)
        .then((response) => {
          console.log("Data sent successfully:", response.data);
          alert('Data sent successfully');
          setFormdata({
            name: "",
            email: "",
            regarding: "",
            news: "",
          })
          // Handle the response, e.g., display a success message
        })
        .catch((error) => {
          console.error("Error sending data:", error);
          // Handle error, e.g., display an error message
        });
    }
  };


  function onChange(value) {

  }

  return (
    <>
      <Navbar />
      <div id='above'>
        <div id='formcontainer'>
        <p>/ Write to us /</p>
            <div id='loo'>
              <h1>
                We look forward to<br></br>connecting with<br></br>you
                <br></br>
              </h1>
            </div>
          <p>
          If you need to contact the owner of this website, 
          please reach out via email. For any inquiries or support, 
          send a message to b.essop@techiserve.com We will respond as soon as possible.
          </p>
        </div>

      </div>
      <Footer2 />
    </>
  );
};

export default Contect;
